import React, { useState, useEffect } from 'react';

import './static/css/gaspass.css';
import './static/css/colors.css';
import './static/css/sizes.css';

import {Common} from "./libs/Common";
import {Storage} from "./libs/Storage";
import {Session} from "./libs/Session";
import {Query} from "./libs/Query";

import ControllerMenu from "./controllers/Menu";
import ControllerBlockForm from "./controllers/BlockForm";
import ControllerDataForm from "./controllers/DataForm";
import ControllerInfoForm from "./controllers/InfoForm";
import ControllerEditForm from "./controllers/EditForm";
import ControllerQuestionForm from "./controllers/QuestionForm";
import ControllerNotFound from "./controllers/NotFound";

export let gpCommon = null;
export let gpStorage = null;
export let gpSession = null;

export let gpTemporary = {};

const GasPass = () => {

    const [gaspassInitialized, setGasPassInitialized] = useState( false );
    const [clientAuthorized, setClientAuthorized] = useState( false );
    const [serviceName, setServiceName] = useState( '' );

    const [yandexMapApi, setYandexMapApi] = useState( null );

    const [menu, setMenu] = useState( null );
    const [navigation, setNavigation] = useState( null );
    const [data, setData] = useState( null );
    const [popup, setPopup] = useState( null );

    useEffect(() => {

        gpCommon = new Common();
        gpStorage = new Storage();
        gpSession = new Session();

        gpSession.setAuthorized( setClientAuthorized );
/*
        console.error = function filterErrors( msg, ...args ) {
            if( !['state update on an unmounted component'].some( ( entry ) => msg.includes( entry ) ) ) {
                console.error( msg, ...args );
            }
        };
*/
        window.onpopstate = ( e ) => {
            setData( gpCommon.getObject( e.state.data, null ) );
            setNavigation( gpCommon.getArray( e.state.navigation, null ) );
            setPopup( null );

            setTimeout( function() {
                window.scrollTo( 0, 0 );
            }, 50 );
        };

        if( gpSession.isSession() ) {
            // Есть активная сессия
            setClientAuthorized( true );

            requireUrl( 'main', {}, null );

            if( gpCommon.getString( window.location.pathname, null ) !== null ) {
                let url = window.location.pathname.substring( 1 );
                if( gpCommon.getString( url, null ) !== null ) {
                    requireUrl( url, {}, null );
                }
            }

        }
        else {
            // Требуется авторизация
            requireAuthorization();
        }

        new Promise(function( resolve, reject ) {
            let scriptElement = document.createElement('script' );
            scriptElement.onload = resolve;
            scriptElement.onerror = reject;
            scriptElement.async = true;
            scriptElement.defer = true;
            scriptElement.type = 'text/javascript';
            scriptElement.src = 'https://api-maps.yandex.ru/2.1/?lang=ru';
            document.body.appendChild( scriptElement );
        }).then( function() {
            new Promise(function( resolve ) {
                return ymaps.ready( resolve );
            }).then( function() {
                setYandexMapApi( ymaps );
            });
        }).catch( function() {
            //
        });

        setGasPassInitialized( true );

        if( ( typeof window.location != "undefined" ) && ( typeof window.location.hostname != "undefined" ) ) {
            let hostname = gpCommon.getString( window.location.hostname, null );
            if( hostname !== null ) {
                let newTitleName = 'GasPass';
                let newServiceName = 'GASPASS';

                if( hostname.includes( '.nakolonke.' ) ) {
                    newTitleName = 'Nakolonke';
                    newServiceName = 'Nakolonke';
                }
                if( ( hostname.length > 3 ) && ( hostname.substring( 0, 3 ).toLowerCase() === 'lk.' ) ) {
                    newTitleName += ' :: Личный кабинет';
                    newServiceName += ' - Личный кабинет';
                }
                document.title = newTitleName;
                setServiceName( newServiceName );
            }
        }

    }, [] );

    useEffect( () => {
        if( gaspassInitialized && !clientAuthorized ) {
            requireAuthorization();
        }
    }, [clientAuthorized, gaspassInitialized] );

    useEffect( () => {
        if( data !== null ) {
            let dataUrl = gpCommon.getString( data['url'], null );
            let currentPath = null;
            if( typeof window.location.pathname != "undefined" ) {
                currentPath = window.location.pathname;
            }
            if( dataUrl !== null ) {
                if( currentPath === '/' + dataUrl ) {
                    history.replaceState( { data: data, navigation: navigation }, gpCommon.getString( data['title'], '' ), '/' + dataUrl );
                }
                else {
                    history.pushState( { data: data, navigation: navigation }, gpCommon.getString( data['title'], '' ), '/' + dataUrl );
                    window.scrollTo( 0, 0 );
                }
            }
        }

    }, [data, navigation] );


    if( gaspassInitialized ) {
        let dataType = data !== null ? gpCommon.getString( data['type'], null ) : null;
        let popupType = popup !== null ? gpCommon.getString( popup['type'], null ) : null;

        return (
            <div>
                <ControllerMenu menu={menu} navigation={navigation} data={data} serviceName={serviceName} requireUrl={requireUrl} />

                {dataType === 'blockForm' && <ControllerBlockForm data={data} requireUrl={requireUrl} setPopup={setPopup} yandexMapApi={yandexMapApi} />}
                {dataType === 'dataForm' && <ControllerDataForm data={data} requireUrl={requireUrl} setPopup={setPopup} inBlock={false} />}
                {dataType === 'infoForm' && <ControllerInfoForm data={data} requireUrl={requireUrl} inBlock={false} yandexMapApi={yandexMapApi} />}
                {dataType === 'editForm' && <ControllerEditForm data={data} setData={setData} setPopup={setPopup} setNavigation={setNavigation} setMenu={setMenu} yandexMapApi={yandexMapApi} />}
                {dataType === 'questionForm' && <ControllerQuestionForm data={data} setData={setData} setPopup={setPopup} setNavigation={setNavigation} setMenu={setMenu} />}
                {dataType === 'notFound' && <ControllerNotFound data={data} />}

                <div className={popupType !== null ? "popup popupVisible" : "popup"}>
                    {popupType === 'dataForm' && <ControllerDataForm data={popup} requireUrl={requireUrl} setPopup={setPopup} inBlock={true} />}
                    {popupType === 'infoForm' && <ControllerInfoForm data={popup} requireUrl={requireUrl} inBlock={true} yandexMapApi={yandexMapApi} />}
                    {popupType === 'editForm' && <ControllerEditForm data={popup} setData={setData} setPopup={setPopup} setNavigation={setNavigation} setMenu={setMenu} yandexMapApi={yandexMapApi} />}
                    {popupType === 'questionForm' && <ControllerQuestionForm data={popup} setData={setData} setPopup={setPopup} setNavigation={setNavigation} setMenu={setMenu} />}
                </div>
            </div>
        );
    }

    return null;

    function requireUrl( url, params, callback ) {
        new Query().get( url, params, ( response ) => {
            //
            let responseStatus = gpCommon.getString( response['status'], '' );
            if( responseStatus === 'ok' ) {
                // Successful
                if( typeof response['data'] != "undefined" ) {
                    let data = gpCommon.getObject( response['data'], null );
                    setData( data );
                }

                if( typeof response['popup'] != "undefined" ) {
                    let popup = gpCommon.getObject( response['popup'], null );
                    setPopup( popup );
                }

                if( typeof response['menu'] != "undefined" ) {
                    let menuData = gpCommon.getArray( response['menu'], null );
                    setMenu( menuData );
                }

                if( typeof response['navigation'] != "undefined" ) {
                    let navigation = gpCommon.getArray( response['navigation'], null );
                    setNavigation( navigation );
                }

                if( typeof callback == "function" ) {
                    callback();
                }
            }

        }, ( error ) => {
            //
            if( error.message === 'Not found' )
            {
                setData({
                    type: 'notFound',
                    code: '404',
                    description: 'Указанная страница не найдена'
                })
            }
            else if( error.message === 'No response' )
            {
                setData({
                    type: 'notFound',
                    code: '408',
                    description: 'Не получен ответ при выполнении запроса'
                })
            }
            else {
                setData({
                    type: 'notFound',
                    code: '500',
                    description: 'Внутренняя ошибка при выполнении запроса'
                })
            }
            setPopup( null );
            setNavigation( null );
        });
    }

    function requireAuthorization() {
        setData({
            type: 'editForm',
            title: serviceName,
            subtitle: 'Вход в систему',
            form: [
                {
                    id: 'login',
                    type: 'text',
                    title: 'Логин',
                    subtitle: 'или E-mail',
                    value: '',
                    placeholder: '+7 (000) 000-00-00'
                },
                {
                    id: 'password',
                    type: 'password',
                    title: 'Пароль',
                    value: '',
                    placeholder: '**********'
                }
            ],
            button: [
                {
                    id: 'submit',
                    action: 'submit',
                    url: 'login',
                    value: 'Войти в систему'
                }
            ]
        });
        setPopup( null );
        setMenu( null );
        setNavigation( null );
    }

}
export default GasPass;
